<template>
  <div>
    <b-card>
      <!-- Header -->
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>Version Management</b>
          <b-button variant="outline-dark" size="sm" @click="openUpdateModal">Upload Apk</b-button>
        </div>
      </template>

      <!-- Loader -->
      <div v-if="loader" id="overlay">
        <div class="loader"></div>
      </div>

      <!-- Table & Pagination -->
      <div>
        <b-row>
          <b-col sm="12" class="text-right">
            <p>
              <b>Total Records: <span style="color:red;">{{ totalRecords }}</span></b>
            </p>
          </b-col>
        </b-row>
        <b-table
          responsive
          show-empty
          :items="items"
          :fields="fields"
          :bordered="true"
          :busy="isBusy" 
          caption-top
          id="my-table"
        >

          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div> 

          <template slot="isactive" slot-scope="row">
            <b-badge
              :variant="row.item.isactive == '1' ? 'success' : 'danger'"
              @click="activeInactive(row.item)"
              class="pt-1 pointer"
            >{{ row.item.isactive == '1' ? 'Active' : 'Inactive' }}</b-badge>
          </template>

          <template slot="upload_apkfile" slot-scope="row">
            <b-button @click="getApkLink(row.item)" variant="outline-dark" size="sm">
              <i class="fa fa-eye"></i>
            </b-button>
          </template> 

          <template slot="remove" slot-scope="row">
            <b-button @click="removeData(row.item)" variant="outline-danger" size="sm">
              <i class="fa fa-trash"></i>
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRecords"
          :per-page="perPage"
          @change="fetchData"
          aria-controls="my-table"
        ></b-pagination>
      </div>

      <!-- Upload Modal -->
      <b-modal size="lg" title="Apk Upload" centered v-model="openModal" hide-footer>
        <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <label>Updated Apk Version Code <span style="color:red;">*</span></label>
                <b-form-input
                  v-model="form.versionCode"
                  v-validate="'required'"
                  :class="{ 'is-invalid': errors.has('form-1.Updated Apk Version Code') }"
                  name="Updated Apk Version Code"
                  placeholder="Enter updated version code"
                  type="number"
                  min="1"
                  step="1"
                ></b-form-input>
                <span v-show="errors.has('form-1.Updated Apk Version Code')" class="help text-danger">
                  {{ errors.first('form-1.Updated Apk Version Code') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Upload Apk file <span style="color:red;">*</span></label>
                <b-form-file
                  v-model="form.apkfile"
                  v-validate="'required'"
                  name="Apk file"
                  placeholder="Upload Apk file"
                  @change="selectFile($event)"
                  :class="{ 'is-invalid': errors.has('form-1.Apk file') }"
                ></b-form-file>
                <span v-show="errors.has('form-1.Apk file')" class="help text-danger">
                  {{ errors.first('form-1.Apk file') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Apk Type <span style="color:red;">*</span></label>
                <b-form-select
                  v-model="form.selected"
                  :options="options"
                  v-validate="'required'"
                  name="Apk Type"
                  :class="{ 'is-invalid': errors.has('form-1.Apk Type') }"
                ></b-form-select>
                <span v-show="errors.has('form-1.Apk Type')" class="help text-danger">
                  {{ errors.first('form-1.Apk Type') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Updated Apk Version Name <span style="color:red;">*</span></label>
                <b-form-input
                  v-model="form.updatedversionName"
                  v-validate="'required'"
                  name="Updated Apk Version Name"
                  placeholder="Enter Updated Apk version Name"
                  :class="{ 'is-invalid': errors.has('form-1.Updated Apk Version Name') }"
                ></b-form-input>
                <span v-show="errors.has('form-1.Updated Apk Version Name')" class="help text-danger">
                  {{ errors.first('form-1.Updated Apk Version Name') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>File Name <span style="color:red;">*</span></label>
                <b-form-input
                  v-model="form.fileName"
                  v-validate="'required'"
                  name="File Name"
                  placeholder="Enter File Name"
                  :class="{ 'is-invalid': errors.has('form-1.File Name') }"
                ></b-form-input>
                <span v-show="errors.has('form-1.File Name')" class="help text-danger">
                  {{ errors.first('form-1.File Name') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Branch Name <span style="color:red;">*</span></label>
                <b-form-input
                  v-model="form.systemName"
                  v-validate="'required'"
                  name="Branch Name"
                  placeholder="Enter Branch Name"
                  :class="{ 'is-invalid': errors.has('form-1.Branch Name') }"
                ></b-form-input>
                <span v-show="errors.has('form-1.Branch Name')" class="help text-danger">
                  {{ errors.first('form-1.Branch Name') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Force Update <span style="color:red;">*</span></label>
                <b-form-select
                  v-model="form.force_Update"
                  :options="forceOptions"
                  v-validate="'required'"
                  name="Force Update"
                  :class="{ 'is-invalid': errors.has('form-1.Force Update') }"
                ></b-form-select>
                <span v-show="errors.has('form-1.Force Update')" class="help text-danger">
                  {{ errors.first('form-1.Force Update') }}
                </span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>System Description <span style="color:red;">*</span></label>
                <b-form-textarea
                  v-model="form.sysDescription"
                  v-validate="'required'"
                  name="System Description"
                  placeholder="Enter System Description"
                  :class="{ 'is-invalid': errors.has('form-1.System Description') }"
                ></b-form-textarea>
                <span v-show="errors.has('form-1.System Description')" class="help text-danger">
                  {{ errors.first('form-1.System Description') }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="text-right">
            <b-button variant="outline-dark" size="md" type="submit">Save</b-button>
            <b-button variant="outline-danger" size="md" class="ml-2" @click="openUpdateModal">Reset</b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- Link Modal -->
      <b-modal size="lg" title="Apk File" centered v-model="openLinkModal" hide-footer>
        <table style="width: 90%;">
          <tr>
            <td><b>Feature ID and Title</b></td>
            <td class="text-center"><b style="color: crimson;">{{ apkdetails.system_description }}</b></td>
          </tr>
          <tr>
            <td><b>Feature Branch Name</b></td>
            <td class="text-center">{{ apkdetails.system_name }}</td>
          </tr>
          <tr>
            <td><b>Version</b></td>
            <td class="text-center">{{ apkdetails.appversion }}</td>
          </tr>
          <tr>
            <td><b>Version Name</b></td>
            <td class="text-center">{{ apkdetails.apk_version_name }}</td>
          </tr>
          <tr>
            <td><b>Build Date</b></td>
            <td class="text-center">{{ apkdetails.formattedDate }}</td>
          </tr>
          <tr>
            <td><b>Android Build(One Drive Link)</b></td>
            <td class="text-center">
              <div class="d-flex justify-content-center">
                <a :href="apkdetails.upload_apkfile" download>{{ apkdetails.upload_apkfile }}</a>
                <b-button @click="copyToClipboard(apkdetails.upload_apkfile)" variant="outline-success" title="Copy APK File Link" size="sm">
                  <i class="fa fa-clipboard"></i>
                </b-button>
                <div v-if="showPopover" class="popover">Copied!</div>
              </div>
            </td>
          </tr>
          <tr>
            <td><b>Environment Details</b></td>
            <td class="text-center">{{ apkdetails.apk_type }}</td>
          </tr>
        </table>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Swal from 'sweetalert2';

export default {
  name: 'versionmgmt',
  data() {
    return {
      perPage: 15,
      currentPage: 1,
      form: {
        apkfile: null,
        selected: null,
        force_Update: null,
        versionCode: '',
        updatedversionName: '',
        fileName: '',
        systemName: '',
        sysDescription: ''
      },
      apkfile: '',
      items: [],
      fields: [
        { key: 'filename', label: 'File Name', sortable: true },
        { key: 'system_name', label: 'Branch Name', sortable: true },
        { key: 'appversion', label: 'Apk Version Code', class: 'text-center' },
        { key: 'apk_version_name', label: 'Apk Version Name' },
        { key: 'upload_apkfile', label: 'Apk File', class: 'text-center'  },
        { key: 'isactive', label: 'Force Update', class: 'text-center'  },
        { key: 'remove', label: 'Action', class: 'text-center'  }
      ],
      options: [
        { value: null, text: 'Please Select' },
        { value: 'Live', text: 'Live' },
        { value: 'Stage', text: 'Stage' }
      ],
      forceOptions: [
        { value: null, text: 'Please Select' },
        { value: '1', text: 'Yes' },
        { value: '0', text: 'No' }
      ],
      openModal: false,
      loader: false,
      isBusy: false,
      openLinkModal: false,
      apkdetails: { formattedDate: '' },
      showPopover: false,
      totalRecords: 0
    };
  },
  created() {
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.isSuperAdmin = userInfo.is_superadmin
    this.fetchData(this.currentPage);
  },
  methods: {
    openUpdateModal() {
      this.form = {
        apkfile: null,
        selected: null,
        force_Update: null,
        versionCode: '',
        updatedversionName: '',
        fileName: '',
        systemName: '',
        sysDescription: ''
      };
      this.apkfile = '';
      this.openModal = true;
    },
    fetchData(page = this.currentPage) {
      // this.loader = true;
      this.isBusy = true;
      this.currentPage = page;
      const obj = { pageno: page, limit: this.perPage };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAppVersionSettings`, obj).then((result) => {
        this.isBusy = false;
        if (result.body.returnmsg === 'Successful') {
          this.items = result.body.returnvalue;
          this.totalRecords = result.body.totalcount;
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000
          });
          this.items = [];
          this.totalRecords = 0;
        }
      }).catch((err) => { 
        this.isBusy = false; 
        this.items = [];
        this.totalRecords = 0;
        this.$fire({
          text: err.message,
          type: "error",
          timer: 30000
        });
      });
    },
    selectFile(event) {
      this.loader = true;
      let tempFile = event.target.files[0];
      if (tempFile) {
        let filedata = new FormData();
        filedata.append('file', tempFile);
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/uploadImageToS3`, filedata, {
          header: { 'Content-Type': 'multipart/form-data' }
        })
        .then(Response => {
          this.loader = false;
          if (Response.body.result === 'success') {
            this.apkfile = Response.body.image_url;
          }
        })
        .catch(error => {
          this.loader = false;
        });
      }
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.uploadApk();
        }
      });
    },
    uploadApk() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.loader = true;
      let obj = {
        appVersionCode: this.form.versionCode,
        apkUrl: this.apkfile,
        apkType: this.form.selected,
        systemName: this.form.systemName,
        forceUpdate: this.form.force_Update,
        fileName: this.form.fileName,
        apkVersionName: this.form.updatedversionName,
        systemDescription: this.form.sysDescription,
        createdBy: userInfo.sysemailid
      };
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/addAppVersionSettings`, obj)
      .then((result) => {
        this.loader = false;
        if (result.body.returnmsg === "Successful") {
          this.$fire({
            text: result.body.returnmsg,
            type: "success",
            timer: 30000
          });
          this.openModal = false;
          this.fetchData(1);
        } else {
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000
          });
        }
      })
      .catch(error=>{
        this.loader = false;
      })
    },
    getApkLink(value) {
      this.apkdetails = { ...value };
      this.openLinkModal = true;
      this.apkdetails.formattedDate = this.formatDate(this.apkdetails.createddate);
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    copyToClipboard(link) {
      navigator.clipboard.writeText(link).then(() => {
        this.showPopover = true;
        setTimeout(() => { this.showPopover = false; }, 1500);
      });
    },
    activeInactive(value) {
      Swal.fire({
        title: "<h3>Confirm Approval</h3><hr>",
        html: `
                        Are you sure you want to Force Update? 
                        <br/><br/>
                    `,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        confirmButtonColor: "#00c0ef",
        cancelButtonText: "Close",
        cancelButtonColor: "#F8943F",
      }).then((result) => {
        this.loader = true;
        if (result.value) {
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          let obj = {
            id: value.id,
            forceUpdate: value.isactive == true ? '0' : '1',
            createdBy: userInfo.sysemailid,
          };
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/updateAppSettings`, obj)
          .then(result => {
            this.loader = false;
            if (result.body.returnmsg === 'Successful') {
              this.$fire({
                text: result.body.returnmsg,
                type: "success",
                timer: 30000
              });
              this.fetchData(1);
            } else {
              this.$fire({
                text: result.body.returnmsg,
                type: "error",
                timer: 30000
              });
            }
          })
          .catch(error=>{
            this.loader = false;
          })
        } else {
          this.loader = false;
        }
      });
    },
    removeData(value) {
      Swal.fire({
        title: "<h3>Confirm Approval</h3><hr>",
        html: `
                        Are you sure you want to Delete? 
                        <br/><br/>
                    `,
        showCancelButton: true,
        confirmButtonText: "Confirm",
        confirmButtonColor: "#00c0ef",
        cancelButtonText: "Close",
        cancelButtonColor: "#F8943F",
      }).then((result) => {
        this.loader = true;
        if (result.value) {
          const object = { id: value.id };
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deleteAppVersionSettings`, object)
          .then((result) => {
            this.loader = false;
            if (result.body.returnmsg === 'Successful') {
              this.$fire({
                text: result.body.returnmsg,
                type: "success",
                timer: 30000
              });
              this.fetchData(1);
            } else {
              this.$fire({
                text: "App version already exists!",
                type: "error",
                timer: 30000
              });
              this.items = [];
            }
          })
          .catch(error=>{
            this.loader = false;
            this.$fire({
              text: error.message,
              type: "error",
              timer: 30000
            });
          })

        }
      });
    }
  }
};
</script>

<style scoped>
.pointer { cursor: pointer; }
.popover {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

#overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #343a40;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
